import React, { useState } from 'react';
import { formatCurrency } from '../utils/investmentIndicatorsHelper';

const CostesExtraModal = ({ isOpen, costesData, onClose }) => {
    const [expandedCategories, setExpandedCategories] = useState({});

    if (!isOpen || !costesData) return null;

    const { detalles, totalesPorCategoria } = costesData;
    const totalGeneral = Object.values(totalesPorCategoria || {}).reduce((sum, total) => sum + total, 0);

    const toggleCategory = (categoria) => {
        setExpandedCategories(prev => ({
            ...prev,
            [categoria]: !prev[categoria]
        }));
    };

    const getCategoryIcon = (categoria) => {
        const icons = {
            mobiliario: '🪑',
            electrodomesticos: '🔌',
            ajuar: '🛏️',
            licencias: '📋'
        };
        return icons[categoria] || '📦';
    };

    const getCategoryTitle = (categoria) => {
        const titles = {
            mobiliario: 'Mobiliario',
            electrodomesticos: 'Electrodomésticos',
            ajuar: 'Ajuar y Textiles',
            licencias: 'Licencias y Trámites'
        };
        return titles[categoria] || categoria.charAt(0).toUpperCase() + categoria.slice(1);
    };

    return (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
            <div className="bg-white rounded-xl shadow-2xl max-w-4xl w-full max-h-[90vh] overflow-hidden">
                {/* Header */}
                <div className="bg-purple-600 text-white p-6">
                    <div className="flex items-center justify-between">
                        <h2 className="text-2xl font-bold">💼 Detalle de Costes Extra - Alquiler Vacacional</h2>
                        <button
                            onClick={onClose}
                            className="text-white hover:text-purple-200 text-2xl font-bold"
                        >
                            ×
                        </button>
                    </div>
                    <p className="text-purple-100 mt-2">Desglose completo de mobiliario, electrodomésticos, ajuar y licencias</p>
                </div>

                {/* Content */}
                <div className="p-6 overflow-y-auto max-h-[calc(90vh-120px)]">
                    {/* Total */}
                    <div className="bg-purple-50 p-4 rounded-lg border-2 border-purple-200 mb-6">
                        <div className="flex items-center justify-between">
                            <h3 className="text-lg font-bold text-purple-800">💰 Total Costes Extra</h3>
                            <p className="text-2xl font-bold text-purple-600">{formatCurrency(totalGeneral)}</p>
                        </div>
                    </div>

                    {/* Collapsible Categories */}
                    <div className="space-y-4">
                        {Object.entries(detalles || {}).map(([categoria, items]) => (
                            <div key={categoria} className="border rounded-lg overflow-hidden">
                                {/* Category Header - Always Visible */}
                                <div 
                                    className="bg-gray-100 px-4 py-3 border-b cursor-pointer hover:bg-gray-200 transition-colors"
                                    onClick={() => toggleCategory(categoria)}
                                >
                                    <div className="flex items-center justify-between">
                                        <div className="flex items-center gap-3">
                                            <span className="text-2xl">{getCategoryIcon(categoria)}</span>
                                            <h3 className="font-semibold text-gray-800">{getCategoryTitle(categoria)}</h3>
                                            <span className="text-sm text-gray-600">({items.length} items)</span>
                                        </div>
                                        <div className="flex items-center gap-3">
                                            <span className="font-bold text-purple-600">
                                                {formatCurrency(totalesPorCategoria?.[categoria] || 0)}
                                            </span>
                                            <span className="text-gray-500 text-lg">
                                                {expandedCategories[categoria] ? '▼' : '▶'}
                                            </span>
                                        </div>
                                    </div>
                                </div>
                                
                                {/* Category Details - Collapsible */}
                                {expandedCategories[categoria] && (
                                    <div className="divide-y">
                                        {items.map((item, index) => (
                                            <div key={index} className="px-4 py-3 hover:bg-gray-50">
                                                <div className="flex items-center justify-between">
                                                    <div className="flex-1">
                                                        <p className="font-medium text-gray-800">{item.nombre}</p>
                                                        <p className="text-sm text-gray-600">
                                                            {parseFloat(item.cantidad).toLocaleString()} × {formatCurrency(item.coste_unitario)} = {formatCurrency(item.total)}
                                                        </p>
                                                    </div>
                                                    <div className="text-right">
                                                        <p className="font-semibold text-gray-900">{formatCurrency(item.total)}</p>
                                                    </div>
                                                </div>
                                            </div>
                                        ))}
                                    </div>
                                )}
                            </div>
                        ))}
                    </div>
                </div>

                {/* Footer */}
                <div className="bg-gray-50 px-6 py-4 border-t">
                    <div className="flex justify-end">
                        <button
                            onClick={onClose}
                            className="bg-purple-600 hover:bg-purple-700 text-white px-6 py-2 rounded-lg font-semibold transition-colors"
                        >
                            Cerrar
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default CostesExtraModal; 